document.documentElement.classList.remove('no-js')

const formatMoney = (cents) => {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents)
  const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100)
  } catch (_) {
    return `$${(cents / 100).toFixed(2)}`
  }
}

const initializeCarousel = (carousel) => {
  if (carousel.dataset.ready === 'true') return
  if (carousel.hasAttribute('data-shuffle-products')) {
    const cards = Array.from(carousel.children)
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1))
      ;[cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]]
    }
    cards.forEach((card) => carousel.appendChild(card))
  }
  const shell = carousel.closest('.carousel-shell')
  const previous = shell ? shell.querySelector('[data-carousel-previous]') : null
  const next = shell ? shell.querySelector('[data-carousel-next]') : null
  const distance = () => Math.max(carousel.clientWidth * 0.82, 280)
  if (previous) previous.addEventListener('click', () => carousel.scrollBy({ left: -distance(), behavior: 'smooth' }))
  if (next) next.addEventListener('click', () => carousel.scrollBy({ left: distance(), behavior: 'smooth' }))
  carousel.dataset.ready = 'true'
}

const initializeAllCarousels = (root = document) => root.querySelectorAll('[data-carousel]').forEach(initializeCarousel)

const initializeMenu = () => {
  const toggle = document.querySelector('[data-menu-toggle]')
  const drawer = document.querySelector('[data-mobile-menu]')
  const header = document.querySelector('[data-header]')
  if (!toggle || !drawer || !header) return
  const close = () => {
    toggle.setAttribute('aria-expanded', 'false')
    drawer.hidden = true
    drawer.scrollTop = 0
    document.body.classList.remove('menu-open')
  }
  const open = () => {
    drawer.style.top = `${Math.max(0, header.getBoundingClientRect().bottom)}px`
    toggle.setAttribute('aria-expanded', 'true')
    drawer.hidden = false
    document.body.classList.add('menu-open')
  }
  toggle.addEventListener('click', () => toggle.getAttribute('aria-expanded') === 'true' ? close() : open())
  drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', close))
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close() })
  window.addEventListener('resize', () => { if (window.innerWidth > 1100) close() })
}

const initializeGallery = (gallery) => {
  const track = gallery.querySelector('[data-gallery-track]')
  const slides = gallery.querySelectorAll('[data-gallery-slide]')
  const previous = gallery.querySelector('[data-gallery-previous]')
  const next = gallery.querySelector('[data-gallery-next]')
  const counter = gallery.querySelector('[data-gallery-current]')
  const dots = gallery.querySelectorAll('[data-gallery-dot]')
  if (!track || slides.length < 2) return
  let active = 0
  let touchStart = 0
  const show = (index) => {
    active = (index + slides.length) % slides.length
    track.style.transform = `translateX(-${active * 100}%)`
    if (counter) counter.textContent = active + 1
    dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === active ? 'true' : 'false'))
  }
  if (previous) previous.addEventListener('click', () => show(active - 1))
  if (next) next.addEventListener('click', () => show(active + 1))
  dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.galleryDot))))
  gallery.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX }, { passive: true })
  gallery.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStart
    if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1))
  }, { passive: true })
}

const initializeProduct = (root) => {
  const form = root.querySelector('[data-product-form]')
  const variantData = root.querySelector('[data-product-variants]')
  if (!form || !variantData) return
  let variants = []
  try { variants = JSON.parse(variantData.textContent) } catch (_) { return }
  const optionGroups = form.querySelectorAll('[data-option-position]')
  const idInput = form.querySelector('[data-variant-id]')
  const addButton = form.querySelector('[data-add-to-cart]')
  const price = root.querySelector('[data-product-price]')
  const updateVariant = () => {
    const selected = Array.from(optionGroups).map((group) => {
      const input = group.querySelector('input:checked')
      const selectedLabel = group.querySelector('[data-selected-option]')
      if (selectedLabel && input) selectedLabel.textContent = input.value
      return input ? input.value : ''
    })
    const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]))
    if (!variant) {
      addButton.disabled = true
      addButton.textContent = 'Unavailable'
      return
    }
    idInput.value = variant.id
    addButton.disabled = !variant.available
    addButton.textContent = variant.available ? 'Add to cart' : 'Sold out'
    if (price) price.textContent = formatMoney(variant.price)
    window.history.replaceState({}, '', `${root.dataset.productUrl}?variant=${variant.id}`)
    if (variant.featured_media) {
      const slide = root.querySelector(`[data-media-id="${variant.featured_media.id}"]`)
      const dot = slide ? root.querySelector(`[data-gallery-dot="${Array.from(slide.parentNode.children).indexOf(slide)}"]`) : null
      if (dot) dot.click()
    }
  }
  optionGroups.forEach((group) => group.addEventListener('change', updateVariant))
}

const initializeSort = () => {
  document.querySelectorAll('[data-sort-by]').forEach((select) => select.addEventListener('change', () => {
    const url = new URL(window.location.href)
    url.searchParams.set('sort_by', select.value)
    window.location.assign(url.toString())
  }))
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html')
          const recommendations = html.querySelector('product-recommendations')
          if (recommendations && recommendations.innerHTML.trim()) {
            this.innerHTML = recommendations.innerHTML
            initializeAllCarousels(this)
          }
        })
        .catch(() => {})
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initializeMenu()
  initializeAllCarousels()
  document.querySelectorAll('[data-product-gallery]').forEach(initializeGallery)
  document.querySelectorAll('[data-product-root]').forEach(initializeProduct)
  initializeSort()
})

document.addEventListener('shopify:section:load', (event) => {
  initializeAllCarousels(event.target)
  event.target.querySelectorAll('[data-product-gallery]').forEach(initializeGallery)
  event.target.querySelectorAll('[data-product-root]').forEach(initializeProduct)
})
